import firebaseAnalyticsClient from './firebaseAnalyticsClient'

export default firebaseAnalyticsClient
